import api from '../../../../App/socket';

export const inviteUserDepartment = () => (
    api.send({
        api: 'db',
        model: 'Department',
        action: 'Read',
        options: {
            attributes: ['id', 'name'],
        },
    }).then(response => response.options).catch(error => error)
);

export const inviteUserRoles = () => (
    api.send({
        api: 'db',
        model: 'User_group',
        action: 'Read',
        options: {
            attributes: ['id', 'name'],
        },
    }).then(response => response.options).catch(error => error)
);

export const inviteUserGender = () => (
    api.send({
        api: 'db',
        model: 'Gender',
        action: 'Read',
        options: {
            attributes: ['id', 'name'],
        },
    }).then(response => response.options).catch(error => error)
);

export const inviteUserNamePrefixes = () => (
    api.send({
        api: 'db',
        model: 'Prefix_name',
        action: 'Read',
        options: {
            attributes: ['id', 'name'],
        },
    }).then(response => response.options).catch(error => error)
);

export const inviteLeadSources = () => (
    api.send({
        api: 'db',
        model: 'Lead_source',
        action: 'Read',
        options: {
            attributes: ['id', 'name'],
        },
    }).then(response => response.options).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/requests/user_profile_requests/invite_user_data_request.js